import { useMemo } from 'react';

/**
 * Returns the language setting from the language config. The config is stored in the window object because it
 * will be fetched from the backend via a script tag before the react-app initializes.
 */
const useAppLanguage = () =>
  useMemo(
    () =>
      Object.entries(window.languageConfig || {}).reduce(
        (acc: string[], [key, value]) => (value ? [...acc, key] : acc),
        [],
      ),
    [],
  );

export default useAppLanguage;
